import Observable from 'ol/Observable';

/**
 * The generic component.
 */
export default class GMComponent extends Observable {
  /**
     * @constructor
     * @param {HTMLElement} dom The Component dom.
     */
  constructor(dom) {
    super();
    this.dom = dom;
  }

  /**
     * Get the root html element of the component.
     * @returns {HTMLElement} The root html element of the component.
     */
  getDOM() {
    return this.dom;
  }

  /**
     * Add a css class to the component.
     * @param {string[]} className The class name.
     */
  addClass(...className) {
    this.dom.classList.add(...className)
  }

  /**
     * Remove a css class to the component.
     * @param {string[]} className The class name.
     */
  removeClass(...className) {
    this.dom.classList.remove(...className)
  }

  /**
     * Append child in the component.
     * @param {HTMLElement} child The child to append.
     */
  appendChild(child) {
    this.dom.appendChild(child);
  }

  // eslint-disable-next-line class-methods-use-this
  clear() {}
}
